import { useMemo } from 'react';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { ConcreteColumnDefinitionData } from '../column-definition.enum';
import { useQueueStore } from '../context/use-queue-store';
import { useColumnDisplayNames } from './use-column-display-names';

export function useAvailableColumns(): ConcreteColumnDefinitionData[] {
    const store = useQueueStore();
    const enabledFeatures = useEnabledFeatures();
    const columnDisplayNames = useColumnDisplayNames();

    return useMemo(() => {
        return store.workspacePanel.queue.availableColumns
            .sort((columnA, columnB) =>
                columnDisplayNames[columnA.name].displayName.localeCompare(
                    columnDisplayNames[columnB.name].displayName
                )
            )
            .filter((column) => {
                return column.getIsEnabled ? column.getIsEnabled(enabledFeatures) : true;
            });
    }, [columnDisplayNames, enabledFeatures, store.workspacePanel.queue.availableColumns]);
}
